const state = {
    equipment: 'computer',
}
const mutations = {
    setEquipment(state, model) {
        state.equipment = model
    },
}
const actions = {

}
export default {
    namespaced: true,
    state,
    mutations,
    actions,
};